import { Box } from '@unifyapps/ui/components/Box';
import { Stack } from '@unifyapps/ui/components/Stack';
import { useCallback, useState } from 'react';
import { useUserStore } from '../../../../auth/UserStoreProvider';
import { EMPTY_OBJECT } from '../../../../consts/empty';
import { ErrorBoundary } from '../../../ErrorBoundary';
import { NotificationsPanelMode } from '../../types';
import { ErrorState } from '../ErrorState';
import { NotificationsContainer } from '../NotificationsContainer';
import { PanelHeader, PreferencesHeader } from '../NotificationsPanelHeader';
import { Settings } from '../preferences/Settings';

const fallback = <ErrorState />;

const DARK_BORDER_STYLE = {
  '--border-tertiary': 'var(--utility-gray-100)',
} as React.CSSProperties;

type Props = {
  onClose: () => void;
  scheme?: 'light' | 'dark';
};

export function NotificationsPanel({ onClose, scheme }: Props) {
  const [mode, setMode] = useState<NotificationsPanelMode>(NotificationsPanelMode.Notifications);

  const onSettingsClick = useCallback(() => {
    setMode(NotificationsPanelMode.Settings);
  }, []);

  const onBack = useCallback(() => {
    setMode(NotificationsPanelMode.Notifications);
  }, []);

  const userData = useUserStore().hooks.useCurrentUserDetails();
  const loggedInUserId = userData?.user?.id;

  if (!loggedInUserId) {
    return null;
  }

  return (
    <Stack
      className="bg-primary size-full"
      data-color-scheme={scheme}
      direction="column"
      style={scheme === 'dark' ? DARK_BORDER_STYLE : (EMPTY_OBJECT as React.CSSProperties)}
    >
      <Box className="py-md px-lg border-tertiary bg-primary flex justify-between border-b border-solid">
        {mode === NotificationsPanelMode.Notifications ? (
          <PanelHeader
            color="clear"
            onClose={onClose}
            onSettingsClick={onSettingsClick}
            scheme={scheme}
          />
        ) : (
          <PreferencesHeader onBack={onBack} onClose={onClose} />
        )}
      </Box>
      <ErrorBoundary fallback={fallback}>
        {mode === NotificationsPanelMode.Notifications ? (
          <NotificationsContainer scheme={scheme} userId={Number(loggedInUserId)} />
        ) : (
          <Settings onBack={onBack} />
        )}
      </ErrorBoundary>
    </Stack>
  );
}
